// extracted by mini-css-extract-plugin
module.exports = {"landing_page_M":"M_landing_page_M__xgnJQ"};